import { render, staticRenderFns } from "./EventServiceSpecialists.vue?vue&type=template&id=3caec472&"
import script from "./EventServiceSpecialists.vue?vue&type=script&lang=js&"
export * from "./EventServiceSpecialists.vue?vue&type=script&lang=js&"
import style0 from "./EventServiceSpecialists.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports